import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const courses = [
    { id: 1, title: "Introduction to Cloud Computing", category: "Cloud & DevOps", difficulty: "Beginner", description: "An overview of cloud computing and its key services.", takenBy: 150 },
    { id: 2, title: "AWS Fundamentals", category: "Cloud & DevOps", difficulty: "Intermediate", description: "A deep dive into Amazon Web Services and its cloud offerings.", takenBy: 130 },
    { id: 3, title: "Azure Cloud Solutions", category: "Cloud & DevOps", difficulty: "Intermediate", description: "Learn about Microsoft Azure and how to deploy solutions on the cloud.", takenBy: 180 },
    { id: 4, title: "DevOps Fundamentals", category: "Cloud & DevOps", difficulty: "Beginner", description: "Understanding DevOps practices, tools, and methodologies.", takenBy: 220 },
    { id: 5, title: "Continuous Integration and Deployment (CI/CD)", category: "Cloud & DevOps", difficulty: "Intermediate", description: "Learn how to set up CI/CD pipelines for faster deployment.", takenBy: 140 },
    { id: 6, title: "Docker for Cloud & DevOps", category: "Cloud & DevOps", difficulty: "Advanced", description: "Utilizing Docker for containerization and deployment in the cloud.", takenBy: 110 },
    { id: 7, title: "Kubernetes Essentials", category: "Cloud & DevOps", difficulty: "Advanced", description: "Master Kubernetes for managing containerized applications in the cloud.", takenBy: 95 },
    { id: 8, title: "Infrastructure as Code with Terraform", category: "Cloud & DevOps", difficulty: "Advanced", description: "Automating cloud infrastructure using Terraform.", takenBy: 80 },
];

const pageSize = 4;

function CloudDevOps() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredCourses = courses.filter(course => course.difficulty === activeTab);
    const paginatedCourses = filteredCourses.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Cloud & DevOps</Title>
                <Paragraph>Explore essential courses in Cloud Computing and DevOps practices to manage and deploy scalable cloud infrastructure and automate software development processes.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedCourses.map((course) => (
                        <Col xs={24} sm={12} md={6} key={course.id}>
                            <Card hoverable>
                                <Title level={5}>{course.title}</Title>
                                <Tag color="blue">{course.category}</Tag>
                                <Tag color={course.difficulty === "Beginner" ? "green" : course.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {course.difficulty}
                                </Tag>
                                <Paragraph>{course.description}</Paragraph>
                                <Paragraph><UserOutlined /> {course.takenBy} students enrolled</Paragraph>
                                <Button type="primary">Start Course</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredCourses.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default CloudDevOps;
